<template>
  <div class="container aside">
    <div
      class="menu_item pointer"
      :class="chooseNum === index ? 'is_active' : ''"
      v-for="(item, index) in menuList"
      :key="item.icon"
      @click="() => chooseItem(index, item)"
    >
      <SvgComponent :iconName="item.icon" />
      <span>{{ item.title }}</span>
    </div>
  </div>
</template>

<script>
import SvgComponent from "./SvgComponent";

export default {
  name: "AsideMenuComponent",
  components: { SvgComponent },
  data() {
    return {
      chooseNum: 0,
      menuList: [
        {
          icon: "index",
          title: "首页",
          path: "/index",
        },
        {
          icon: "lag",
          title: "文案",
          path: "/language",
        },
        {
          icon: "clip",
          title: "音视频操作",
          path: "/clip",
        },
        {
          icon: "map",
          title: "地图标记",
          path: "/map",
        },
        {
          icon: "plan",
          title: "营销文案",
          path: "/plan",
        },
      ],
    };
  },
  methods: {
    chooseItem(num, item) {
      console.log(num, item);
      this.chooseNum = num;
      this.$router.push(item.path);
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/common/style/index";

.aside {
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;
  padding: 10px;

  .menu_item {
    display: flex;
    gap: 10px;
    padding: 0 20px;
    box-sizing: border-box;
    height: 2.5rem;
    line-height: 2.5rem;
    width: 100%;
    border-radius: 10px;
    font-size: 0.8rem;
    margin: 0;
    color: $main_font_color;
    transition: 0.1s linear;
  }

  .is_active {
    background-color: $main_theme_color;
    color: #ffffff;
    font-weight: bolder;
  }
}
</style>
